<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--singin" id="m_login">
      <router-view></router-view>
      <div class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1	m-login__content" >
        <div class="m-grid__item m-grid__item--middle">
          <h3 class="m-login__welcome">
            {{ 'welcome_message' | capitalize }}
          </h3>
          <p class="m-login__msg">
            {{ 'superaccess_text' | capitalize }}
          <br><br>
            {{ 'portal local' | capitalize }}
          <br>
            {{ 'test_version_text' | capitalize }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({getLanguage: 'getLocalLanguage', userData: 'getUserData'})
  },
  created () {
    if (this.getLanguage !== '') {
      this.$i18n.locale = this.getLanguage
      this.$validator.localize(this.getLanguage)
    } else {
      this.$i18n.locale = (navigator.language || navigator.userLanguage).substring(0, 2)
      this.$validator.localize((navigator.language || navigator.userLanguage).substring(0, 2))
    }
  }
}
</script>


// WEBPACK FOOTER //
// Login.vue